/* ============================================================
   ÉTAPE 4: GESTION DES DATES (Refactorisée)
   ============================================================ */

import { useEffect, useState } from 'react';
import { DurationCalculation } from '../DurationCalculation';
import { DurationOptions } from '../DurationOptions';
import { ReservationTypeSelector } from '../ReservationTypeSelector';
import { SaveButton } from '../SaveButton';

interface Step4DateManagementProps {
  data: any;
  onChange: (updates: any) => void;
  onSave?: () => void;
  isSaving?: boolean;
}

export function Step4DateManagement({ data, onChange, onSave, isSaving }: Step4DateManagementProps) {
  const [state, setState] = useState({
    allowMultiDay: data.allowMultiDay || false,
    allowHalfDay: data.allowHalfDay ?? true,
    allowFullDay: data.allowFullDay ?? true,
    allowMonth: data.allowMonth || false,
    fullDayHours: data.fullDayHours || 8,
    halfDayHours: data.halfDayHours || 4,
  });

  useEffect(() => {
    onChange(state);
  }, [state]);

  const updateState = (key: string, value: any) => setState((prev) => ({ ...prev, [key]: value }));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
      <ReservationTypeSelector allowMultiDay={state.allowMultiDay} onSelect={(v) => updateState('allowMultiDay', v)} />

      <DurationOptions
        options={{ allowFullDay: state.allowFullDay, allowHalfDay: state.allowHalfDay, allowMonth: state.allowMonth }}
        onChange={updateState}
      />

      <DurationCalculation fullDayHours={state.fullDayHours} halfDayHours={state.halfDayHours} onChange={updateState} />

      <CalculationExample />

      {onSave && <SaveButton onSave={onSave} isSaving={isSaving || false} />}
    </div>
  );
}

function CalculationExample() {
  return (
    <div
      style={{
        padding: '1rem',
        background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
        border: '1px solid #bae6fd',
        borderRadius: '12px',
      }}
    >
      <h4 style={{ fontSize: '0.9rem', fontWeight: 600, color: '#075985', marginBottom: '0.5rem' }}>
        Exemple de calcul
      </h4>
      <p style={{ fontSize: '0.85rem', color: '#0c4a6e', margin: 0 }}>
        Si réservation de 9h à 17h (8 heures) = <strong>Journée complète</strong>
        <br />
        Si réservation de 9h à 13h (4 heures) = <strong>Demi-journée</strong>
      </p>
    </div>
  );
}
